import RetailCollection from 'app/src/data/models/RetailCollection';
import Register from 'app/src/data/models/Register';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class RegisterCollection extends RetailCollection {
  get model() {
    return Register;
  }

  /**
   * Return the REST url for collection of Register models
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/Register.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.Register is an array of the Register structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.Register || [];
  }
}
